<script>
export default {
	props: {
		projects: {
			type: Array,
			required: true,
		},
		index: {
			type: Number,
			default: null,
		},
	},
	emits: ['close', 'prev', 'next'],
	computed: {
		isOpen() {
			return this.index !== null && this.index !== undefined;
		},
		current() {
			return this.isOpen ? this.projects[this.index] : null;
		},
	},
	watch: {
		isOpen(open) {
			const html = document.getElementsByTagName('html')[0];
			if (open) {
				html.classList.add('overflow-y-hidden');
			} else {
				html.classList.remove('overflow-y-hidden');
			}
		},
	},
	mounted() {
		window.addEventListener('keyup', this.onKeyup);
	},
	beforeUnmount() {
		window.removeEventListener('keyup', this.onKeyup);
		document.getElementsByTagName('html')[0].classList.remove('overflow-y-hidden');
	},
	methods: {
		onKeyup(event) {
			if (!this.isOpen) return;
			if (event.key === 'Escape') this.$emit('close');
			if (event.key === 'ArrowLeft') this.$emit('prev');
			if (event.key === 'ArrowRight') this.$emit('next');
		},
	},
};
</script>

<template>
	<Teleport to="body">
		<transition name="lightbox-fade">
			<div
				v-if="isOpen"
				@click="$emit('close')"
				class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 p-4 sm:p-10"
			>
				<!-- Close -->
				<button
					@click.stop="$emit('close')"
					class="absolute top-5 right-5 text-primary-light hover:text-brand-500 duration-300"
					aria-label="Close"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
						class="w-8 h-8"
					>
						<line x1="18" y1="6" x2="6" y2="18"></line>
						<line x1="6" y1="6" x2="18" y2="18"></line>
					</svg>
				</button>

				<!-- Previous -->
				<button
					v-if="projects.length > 1"
					@click.stop="$emit('prev')"
					class="absolute left-3 sm:left-6 top-1/2 -translate-y-1/2 p-2 sm:p-3 clip-corner-sm bg-secondary-dark bg-opacity-80 border border-ternary-dark text-primary-light hover:text-brand-500 hover:border-brand-500 duration-300"
					aria-label="Previous photo"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
						class="w-6 h-6 sm:w-7 sm:h-7"
					>
						<polyline points="15 18 9 12 15 6"></polyline>
					</svg>
				</button>

				<!-- Next -->
				<button
					v-if="projects.length > 1"
					@click.stop="$emit('next')"
					class="absolute right-3 sm:right-6 top-1/2 -translate-y-1/2 p-2 sm:p-3 clip-corner-sm bg-secondary-dark bg-opacity-80 border border-ternary-dark text-primary-light hover:text-brand-500 hover:border-brand-500 duration-300"
					aria-label="Next photo"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
						class="w-6 h-6 sm:w-7 sm:h-7"
					>
						<polyline points="9 18 15 12 9 6"></polyline>
					</svg>
				</button>

				<div class="max-w-5xl max-h-full" @click.stop>
					<img
						v-if="current"
						:src="current.img"
						:alt="current.title"
						class="max-w-full max-h-[80vh] object-contain clip-corner border border-ternary-dark"
					/>
				</div>
			</div>
		</transition>
	</Teleport>
</template>

<style scoped>
.lightbox-fade-enter-active {
	transition: opacity 0.4s cubic-bezier(0.16, 1, 0.3, 1),
		transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}
.lightbox-fade-leave-active {
	transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1),
		transform 0.3s cubic-bezier(0.4, 0, 1, 1);
}
.lightbox-fade-enter-from,
.lightbox-fade-leave-to {
	opacity: 0;
	transform: scale(0.94);
}
</style>
